const characters = 'ABCDEFGHJKMNPQRSTVWXYZabcdefghjk';
export function generateSpeleoId() {
    return [
        ...Array.from({ length: 13 }, () => {
            return characters[Math.floor(Math.random() * characters.length)];
        }),
    ].join('');
}
